var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMore = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white",
    stroke: "var(--asset-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9C9.44772 9 9 9.44771 9 10V15.1111C9 15.6634 9.44771 16.1111 10 16.1111H15.1111C15.6634 16.1111 16.1111 15.6634 16.1111 15.1111V10C16.1111 9.44772 15.6634 9 15.1111 9H10ZM10 17.8889C9.44772 17.8889 9 18.3366 9 18.8889V24C9 24.5523 9.44771 25 10 25H15.1111C15.6634 25 16.1111 24.5523 16.1111 24V18.8889C16.1111 18.3366 15.6634 17.8889 15.1111 17.8889H10ZM17.8889 10C17.8889 9.44771 18.3366 9 18.8889 9H24C24.5523 9 25 9.44772 25 10V15.1111C25 15.6634 24.5523 16.1111 24 16.1111H18.8889C18.3366 16.1111 17.8889 15.6634 17.8889 15.1111V10ZM18.8889 17.8889C18.3366 17.8889 17.8889 18.3366 17.8889 18.8889V24C17.8889 24.5523 18.3366 25 18.8889 25H24C24.5523 25 25 24.5523 25 24V18.8889C25 18.3366 24.5523 17.8889 24 17.8889H18.8889Z",
    fill: "var(--asset-color)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/more.294c1cea.svg";
export { ForwardRef as ReactComponent };